import HcpReporting from './HcpReporting';

export default HcpReporting;
